import { useState, useEffect, memo } from 'react';
import type { MouseEvent } from 'react';
import type { MenuLink, MenuProps, MenuTarget, SeoSidebar } from '../store/types';

import SocialIcon from "./icons/SocialIcon";

const menuLinks: MenuLink[] = [
    { name: 'about', label: 'About', href: '/about' },
    { name: 'connect', label: 'Connect', href: '/connect' },
    { name: 'services', label: 'Skills', href: '/services' },
    { name: 'portfolio', label: 'Portfolio', href: '/my-portfolio' },
];

const Menu = ({ menuOpen: menuOpenProp, activeSidebar: activeSidebarProp, setMenuOpen: setParentMenuOpen, setActiveSidebar: setParentActiveSidebar }: MenuProps) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(menuOpenProp);
    const [showMenu, setShowMenu] = useState<boolean>(false);
    const [activeSidebar, setActiveSidebar] = useState<SeoSidebar>(activeSidebarProp);

    const onBurgerClick = () => {
        setParentMenuOpen(!menuOpenProp);
    };

    useEffect(() => {
        setMenuOpen(menuOpenProp);
        setActiveSidebar(activeSidebarProp);

        setTimeout(() => {
            setShowMenu(true);
        }, 6000);
    }, [menuOpenProp, activeSidebarProp]);

    const onMenuItemClick = (name: MenuTarget) => {
        setParentActiveSidebar(name);
        setParentMenuOpen(false);
    };

    const onMenuLinkClick = (event: MouseEvent<HTMLAnchorElement>, name: MenuTarget) => {
        event.preventDefault();
        onMenuItemClick(name);
    };

    return (
        <div className={`main_menu ` + (showMenu ? '  show ' : '')}>
            <div className={'burger_menu ' + (menuOpen ? ' open ' : '')} onClick={onBurgerClick}>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <div className={"menu_items   " + (menuOpen ? ' open ' : '')}>
                {menuLinks.map((item) => (
                    <a
                        key={item.name}
                        href={item.href}
                        className={"item py-4 " + (activeSidebar === item.name ? " active " : "")}
                        onClick={(event) => onMenuLinkClick(event, item.name)}
                        aria-current={activeSidebar === item.name ? 'page' : undefined}
                    >
                        {item.label}
                    </a>
                ))}
            </div>
            <div className="social_menu_right">
                <SocialIcon platform="instagram" link="https://www.instagram.com/seroujkhandjihanian/" />
                <SocialIcon platform="linkedin" link="https://www.linkedin.com/in/serouj-khandjihanian-895997183/" />
                <SocialIcon platform="mail" link="mailto:seroujkh@hotmail.com" />
            </div>
        </div>
    );
};

export default memo(Menu);
